<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" @close="resetForm" width="600px">
    <template #title>
      <h4>{{isEdit ? $t('编辑') : $t('新增')}}</h4>
    </template>

    <el-form label-width="170px" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('激活码名称')" prop="name">
        <el-input :placeholder="$t('激活码名称')" v-model="formData.name"/>
      </el-form-item>
      <el-form-item :label="$t('日期')" required prop="startTime">
        <date-time-range-picker
            :picker-options="{
                disabledDate: (time) => time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)),
              }"
            :start-time.sync="formData.startTime"
            :end-time.sync="formData.endTime" />
      </el-form-item>
      <el-form-item :label="$t('会员类型')" prop="vipType">
        <dict-select flag="VIP_TYPE" v-model="formData.vipType"/>
      </el-form-item>
      <el-form-item :label="$t('蓝牙MAC状态')" prop="macStatus">
        <el-radio-group v-model="formData.macStatus" :disabled="!isEditMacCode">
          <el-radio label="active">{{$t('激活')}}</el-radio>
          <el-radio label="ban" :disabled="formData.vipType === 'normal'">{{$t('关闭')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('品牌名称')" prop="brandName">
        <el-input :placeholder="$t('品牌名称')" v-model="formData.brandName"  :disabled="isEdit" />
      </el-form-item>
      <el-form-item :label="$t('品牌图片')" prop="brandPhoto">
        <pic-upload
            v-model="formData.brandPhoto"
            width="90px"
            height="90px"
            :download-url="$api.file.downloadImg"
            :action="$api.file.upload"
            :limit="1"/>
        <span style="color: red">{{$t('建议大小')}} 375 * 375</span>
      </el-form-item>
      <el-form-item :label="$t('兑换会员期限')" prop="convertNumber" v-if="formData.vipType === 'cookbook'">
        <el-select v-model="formData.convertNumber">
          <el-option v-for="item in 12" :key="item" :value="item" :label="`${item}${$t('月')}`"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('生成数量')" prop="createCount">
        <el-input :placeholder="$t('生成数量')" v-model.number="formData.createCount" :disabled="isEdit" />
      </el-form-item>
      <el-form-item :label="$t('激活次数上限')" prop="activateCount">
        <el-input :placeholder="$t('激活次数上限')" v-model.number="formData.activateCount" :disabled="isEdit" />
      </el-form-item>
      <el-form-item :label="$t('发放数量')">
        <el-input :placeholder="$t('发放数量')" disabled :value="grantCount"/>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import PicUpload from "@/components/pic-upload/PicUpload";
import DictSelect from "@/components/dict/DictSelect";
import {resetEmpty} from "@/utils/common";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";

// 默认字段
const defaultFormData = {
  convertUnit: "月",
  status: "open",
  macStatus: "active"
}

export default {
  name: "AddOrEdit",
  components: {DateTimeRangePicker, DictSelect, PicUpload},
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        name: "",
        startTime: null,
        endTime: null,
        brandName: "",
        brandPhoto: "",
        vipType: "",
        convertNumber: null,
        createCount: null,
        activateCount: null,
        ...defaultFormData
      },
      rules: {
        name: [{required: true, message: this.$t('请激活码名称'), trigger: "blur"}],
        startTime: [
            {required: true, message: this.$t('请选择开始时间和结束时间'), trigger: "change"}
        ],
        brandName: [{required: true, message: this.$t('请输入品牌名称'), trigger: "blur"}],
        brandPhoto: [{required: true, message: this.$t('请上传品牌图片'), trigger: "change"}],
        vipType: [{required: true, message: this.$t('请选择会员类型'), trigger: "change"}],
        convertNumber: [{required: true, message: this.$t('请选择兑换会员期限'), trigger: "change"}],
        createCount: [
          {required: true, message: this.$t('请输入生成数量'), trigger: "blur"},
          {type: "number", message: this.$t('生成数量必须为数字值'), trigger: "blur"}
        ],
        activateCount: [
          {required: true, message: this.$t('请输入激活次数上限'), trigger: "blur"},
          {type: "number", message: this.$t('激活次数上限必须为数字值'), trigger: "blur"}
        ],
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        const data = {...this.formData};
        // data.startTime = this.$moment(data.startTime).valueOf();
        // data.endTime = this.$moment(data.endTime).valueOf();
        this.$emit("save", data);
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData = {...this.formData, ...defaultFormData};
    }
  },
  computed: {
    // 发放数量
    grantCount() {
      const {createCount, activateCount} = this.formData;
      if (typeof createCount !== "number" || typeof activateCount !== "number") return 0;
      return createCount * activateCount;
    },

    // 是否可编辑激活蓝牙
    isEditMacCode() {
      if(!this.isEdit) return true;
      const {alreadyActCount} = this.data;
      return alreadyActCount < this.grantCount;
    }

  },
  watch: {
    // 监听图片上传及时移除校验信息
    "formData.brandPhoto":  {
      handler(val) {
        if(val) {
          this.$nextTick(() => {
            this.$refs.form.clearValidate("brandPhoto");
          })
        }
      }
    },

    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
        this.formData = {...this.formData, ...defaultFormData};
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}

.el-select {
  width: 100%;
}

</style>
